// for the burger menu in navigation

function openDropdown(dropdownContent: HTMLElement, checkbox: HTMLFormElement) {
    checkbox.checked = true;
    dropdownContent.style.display = "block";
    dropdownContent.style.opacity = "1";
    dropdownContent.classList.add("open");
}
function closeDropdown(
    dropdownContent: HTMLElement,
    checkbox: HTMLFormElement,
) {
    checkbox.checked = false;
    dropdownContent.style.display = "none";
    dropdownContent.style.opacity = "0";
    dropdownContent.classList.remove("open");
}

export function dropdownMenu() {
    const dropdowns = document.querySelectorAll<HTMLFormElement>(
        "[data-menu-dropdown]",
    );
    if (dropdowns.length > 0) {
        dropdowns.forEach((dropdown) => {
            // @ts-ignore
            const dropdownContent = document.getElementById<HTMLElement>(
                dropdown.dataset.menuDropdown,
            );
            const checkbox = document.querySelector<HTMLFormElement>(
                `input[id="${dropdown.getAttribute("for")}"]`,
            );
            dropdown.addEventListener("click", (e) => {
                e.preventDefault();
                // @ts-ignore
                if (!dropdownContent.classList.contains("open")) {
                    // @ts-ignore
                    openDropdown(dropdownContent, checkbox);
                } else {
                    // @ts-ignore
                    closeDropdown(dropdownContent, checkbox);
                }
            });
        });
    }
}
